import React, { useEffect } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "./styles.scss";
import photo from "../../assets/photos/UNM_HS-Wellness_Art-Walk-8-1_WEB.jpg";
function SectionEight({ placeholderSrc }) {
  return (
    <div className="tw-bg-secondary">
      <div className="spacer h-[6rem]"></div>
      <div className="tw-relative -tw-secondary-gradient md:tw-px-8 tw-pb-4">
        <div className="sectionNumber tw-absolute tw-font-extrabold xl:tw-text-[11.0rem] xl:tw-leading-[11.0rem] tw-block">
        8
        </div>
        <LazyLoadImage
          alt="Helix Garden"
          src={photo} // use normal <img> attributes as props
          placeholderSrc={placeholderSrc}
        />
      </div>
      <div className="tw-bg-secondary tw-px-8 tw-pb-4">
        <p className="tw-font-bold tw-italic tw-mb-4 tw-text-2xl">
          Helix Garden
        </p>
        <p>
          A truly unique memorial to honor the many New Mexicans who donated
          their bodies to aid in the education of healthcare professionals at
          UNM, the Helix Garden interposes the structure of the DNA helix with
          the winding greenery of nature. The names of three donors are
          memorialized on the trio of helix columns that stand in the shade of
          this peaceful garden scape.
        </p>
      </div>
    </div>
  );
}

export default SectionEight;
